import { hot } from 'react-hot-loader';
import { useParams } from "react-router-dom";
import Seo from '../components/Seo';
import Footer from '../components/Footer';
import ScreenDetails from '../screens/ScreenDetails';



function DetaisPage(props) {
  let { tokenId } = useParams();

  return (
    <Seo title={`ROBOROVSKI #${tokenId} DETAILS`} meta={[]}>
      <ScreenDetails />
      <Footer />
    </Seo>
  );
};

export default hot(module)(DetaisPage);
